export enum TrialAmplitudeEvent {
  TRIALS_GROUP = "Trials",
  TRIALS_PAGE = "Trials Page",
  TRIAL_DESIGN = "Trial-Design",
  TRIAL_STEPS = "Trial-Steps",
  DOWNLOAD_WORK_ORDER = "Download Work Order",
  TRIAL_COMPLETION_TOGGLE = "trial_completion_toggle",
  CLOSE_TRIAL_REPORT_DRAWER = "Close Trial Report Drawer",
  EDIT_TRIAL = "Edit Trial",
  DELETE_TRIAL = "Delete Trial",
  EXPORT_WORK_ORDER = "Export Work Order",
  CREATE_TRIAL = "Create Trial",
  SAVE_TRIAL = "Save Trial",
  SAVE_AND_SHARE_REPORT = "Save and Share Report",
  SAVE_AND_EXPORT_WORK_ORDER = "Save and Export Work Order",
  TRIAL_MENU_CLICK = "Trial Menu Click",
}

export enum TrialReportAmplitudeEvent {
  TRIAL_REPORTS_GROUP = "Trial Reports",
  TRIAL_REPORTS_PAGE = "Trial Reports Page",
  GENERATE_TRIAL_REPORT = "Generate Trial Report",
  CREATE_TRIAL_REPORT = "Create Trial Report",
  SEND_REPORT_EMAIL = "Send Report Email",
  SHARE_TRIAL_REPORT = "Share Trial Report",
  COPY_REPORT_LINK = "Copy Report Link",
  EDIT_TRIAL_REPORT = "Edit Trial Report",
  OPEN_REPORT_LINK = "Open Report Link",
}

export enum ProtocolAmplitudeEvent {
  PROTOCOLS_GROUP = "Protocols",
  PROTOCOLS_PAGE = "Protocols Page",
  PROTOCOL_STEPS = "Protocol-Steps",
  PROTOCOL = "Protocol",
  PUBLISH_PROTOCOL = "Publish Protocol",
  SAVE_AS_DRAFT = "Save as Draft",
  EDIT_PROTOCOL = "Edit Protocol",
  ARCHIVE_PROTOCOL = "Archive Protocol",
  DELETE_PROTOCOL = "Delete Protocol",
  PROTOCOL_ARCHIVE_CLICKED = "protocol_archive_clicked",
  PROTOCOL_MENU_CLICK = "Protocol Menu Click",
}

export enum ProtocolTemplatesAmplitudeEvent {
  PROTOCOL_TEMPLATE_GROUP = "Protocol Templates",
  PROTOCOL_TEMPLATE_PAGE = "Protocol Templates Page",
  SAVE_AS_TEMPLATE_WORKSPACE_UNIVERSAL = "Save as template (universal / workspace)",
  SAVE_AS_TEMPLATE_WORKSPACE = "Save as Template (workspace)",
  SAVE_AS_TEMPLATE_UNIVERSAL = "Save as Template (universal)",
  DELETE_TEMPLATE = "Delete Template",
  USE_TEMPLATE = "Use Template",
}
